import * as React from "react"
import type { SVGProps } from "react"
export const WarningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.515 20.111a.875.875 0 0 1-.772-.452.96.96 0 0 1-.128-.437.8.8 0 0 1 .127-.467l8.56-14.788a.9.9 0 0 1 .787-.452q.23 0 .44.11a.9.9 0 0 1 .347.342l8.561 14.788q.14.231.127.467a.96.96 0 0 1-.129.437.88.88 0 0 1-.771.452zm1.024-1.5h15.1l-7.55-13zm7.55-1.192q.344 0 .576-.232a.78.78 0 0 0 .232-.576.78.78 0 0 0-.232-.575.78.78 0 0 0-.576-.233.78.78 0 0 0-.575.233.78.78 0 0 0-.232.575q0 .343.232.576a.78.78 0 0 0 .575.232m0-2.616q.32 0 .535-.215a.73.73 0 0 0 .215-.535v-3.5a.73.73 0 0 0-.215-.534.73.73 0 0 0-.535-.216.73.73 0 0 0-.534.216.73.73 0 0 0-.216.534v3.5q0 .32.216.535a.73.73 0 0 0 .535.215"
    />
  </svg>
)
